import React, {useCallback} from 'react';
import SVG, {Props} from 'react-inlinesvg';
import {asREM} from '../../Utilities';

const InlineSvg = ({height, width, ...props}: Omit<Props, 'preProcessor'>) => {
    if (typeof height === 'number') {
        height = asREM(height);
    }
    if (typeof width === 'number') {
        width = asREM(width);
    }
    const preProcessor = useCallback(
        (code: string) =>
            code.includes('stroke')
                ? code.replace(/fill=".*?"/g, 'fill="none"').replace(/stroke=".*?"/g, 'stroke="currentColor"')
                : code.replace(/fill=".*?"/g, 'fill="currentColor"'),
        [props.src]
    );
    return <SVG {...props} height={height} width={width} preProcessor={preProcessor} />;
};

export default InlineSvg;
